export const IntegrationBlog: {
  name: string;
  title: string;
  imageUrl: string;
  badge?: string;
  shortDescription: {
    title: string;
    description: string;
  };
  longDescription: {
    title: string;
    description: string;
  };
  checkFeatures: string[];
}[] = [
  {
    name: 'Calendly',
    title: 'Integration/Calendly/Title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24080506274130_calendly.png',
    badge: 'Integration/popular',
    shortDescription: {
      title: 'Integration/Calendly/Short/Title',
      description: 'Integration/Calendly/Short/Description',
    },
    longDescription: {
      title: 'Integration/Calendly/Long/Title',
      description: 'Integration/Calendly/Long/Description',
    },
    checkFeatures: ['Integration/Calendly/Features/feature1', 'Integration/Calendly/Features/feature2'],
  },
  {
    name: 'WhatsApp',
    title: 'Integration/WhatsApp/Title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24080506281263_whatsapp.png',
    badge: 'Integration/popular',
    shortDescription: {
      title: 'Integration/WhatsApp/Short/Title',
      description: 'Integration/WhatsApp/Short/Description',
    },
    longDescription: {
      title: 'Integration/WhatsApp/Long/Title',
      description: 'Integration/WhatsApp/Long/Description',
    },
    checkFeatures: ['Integration/WhatsApp/Features/feature1', 'Integration/WhatsApp/Features/feature2'],
  },
  {
    name: 'Telegram',
    title: 'Integration/Telegram/Title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24080506280274_telegram.png',
    shortDescription: {
      title: 'Integration/Telegram/Short/Title',
      description: 'Integration/Telegram/Short/Description',
    },
    longDescription: {
      title: 'Integration/Telegram/Long/Title',
      description: 'Integration/Telegram/Long/Description',
    },
    checkFeatures: ['Integration/Telegram/Features/feature1', 'Integration/Telegram/Features/feature2'],
  },
  {
    name: 'AnyExternalLink',
    title: 'Integration/AnyExternalLink/Title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24080506272691_any.png',
    shortDescription: {
      title: 'Integration/AnyExternalLink/Short/Title',
      description: 'Integration/AnyExternalLink/Short/Description',
    },
    longDescription: {
      title: 'Integration/AnyExternalLink/Long/Title',
      description: 'Integration/AnyExternalLink/Long/Description',
    },
    checkFeatures: ['Integration/AnyExternalLink/Features/feature1', 'Integration/AnyExternalLink/Features/feature2'],
  },
  {
    name: 'Stripe',
    title: 'Integration/Stripe/Title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24080506275418_stripe.png',
    shortDescription: {
      title: 'Integration/Stripe/Short/Title',
      description: 'Integration/Stripe/Short/Description',
    },
    longDescription: {
      title: 'Integration/Stripe/Long/Title',
      description: 'Integration/Stripe/Long/Description',
    },
    checkFeatures: ['Integration/Stripe/Features/feature1', 'Integration/Stripe/Features/feature2'],
  },
];
